import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AppManager from "../../../managers/AppManager";
import RouteManager from "../../../managers/RouteManager";
import TimesheetUtils from "../TimesheetUtils";
import TimesheetService from "../TimesheetService";
import AddEmployeeMapping from "./AddEmployeeMapping";
import {
    showLoader,
    removeLoader,
    showToast,
    TOAST_TYPE
} from "deskera-ui-library";
import { MAPPING_COLUMNS } from "../TimesheetConstants";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import { fetchEmployeeListWithoutFilter, selectEmployeeListWithoutLimit } from "../../../Redux/Slices/EmployeeListSlice";
import { fetchBooksContact, selectBooksContact } from "../../../Redux/Slices/BooksContactSlice";
import { fetchProject, selectProject } from "../../../Redux/Slices/ProjectSlice";
import Utility from "../../../utility/Utility";
import { fetchEmployeeMapping, selectEmployeeMapping } from "../../../Redux/Slices/EmployeeMappingSlice";

function EmployeeMapping(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const employeeResponse = useSelector(selectEmployeeListWithoutLimit);
    const project = useSelector(selectProject);
    const booksContact = useSelector(selectBooksContact);
    const employeeMapping = useSelector(selectEmployeeMapping);
    const [showAddMapping, setShowAddMapping] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [mappingData, setMappingData] = useState({
        columnData: MAPPING_COLUMNS,
        rowData: [],
        filter: [],
        originalData: []
    });
    const [fetchingDependencies, setFetchingDependencies] = useState(true);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        fetchDependencies();
        setMappingData({
            ...mappingData,
            columnData: MAPPING_COLUMNS
        });
    }, []);

    useEffect(() => {
        if (!fetchingDependencies) {
            const columns = [...MAPPING_COLUMNS];

            if (!Utility.isEmpty(project)) {
                const ind = columns.findIndex(c => c.columnCode === 'projectId')
                if (ind !== -1) {
                    columns[ind].options = project?.data?.map(e => { return { ...e, label: e.name, value: e.id } }) || [];
                }
            }

            if (!Utility.isEmpty(booksContact)) {
                const ind = columns.findIndex(c => c.columnCode === 'customer')
                if (ind !== -1) {
                    columns[ind].options = booksContact?.map(e => { return { ...e, label: e.name, value: e.customer, id: e.id.toString() } }) || [];
                }
            }

            setMappingData({
                ...mappingData,
                columnData: columns
            });
        }
    }, [fetchingDependencies, employeeResponse, project, booksContact]);

    useEffect(() => {
        if (!Utility.isEmpty(employeeMapping)) {
            if (employeeMapping.data.length > 0) {
                const rowData = TimesheetUtils.getEmployeeMappingRowData(employeeMapping.data, employeeResponse?.users);
                setMappingData({
                    ...mappingData,
                    rowData: rowData,
                    originalData: rowData
                });
            } else {
                setMappingData({
                    ...mappingData,
                    rowData: [],
                    originalData: []
                });
            }
        }
    }, [employeeMapping]);

    const fetchDependencies = async() => {
        showLoader();

        await Promise.all([
            dispatch(fetchEmployeeListWithoutFilter()),
            dispatch(fetchBooksContact()),
            dispatch(fetchProject()),
            await dispatch(fetchEmployeeMapping())
        ]);

        setFetchingDependencies(false);
        removeLoader();
    }

    const getEmployeeMapping = async() => {
        showLoader();
        await dispatch(fetchEmployeeMapping())
        removeLoader();
    }

    const onRowEdit = (data) => {
        if (data?.rowData) {
            TimesheetService.EMPLOYEE_MAPPING = data.rowData.mapping;
            setShowAddMapping(true);
        }
    }

    const onRowDelete = (data) => {
        if (data?.rowData) {
            showLoader("Deleting mapping... Please wait");
            let payload = {
                id:data.rowData.id
            }
            TimesheetService.deleteEmployeeMapping(payload).then(res=>{
                getEmployeeMapping()
                removeLoader();
                showToast("Mapping deleted successfully.", TOAST_TYPE.SUCCESS);
            },error=>{
                removeLoader();
                const message = error && error.message ? error.message : t("SOMETHING_WENT_WRONG")
                showToast(message, TOAST_TYPE.FAILURE);
            })
        }
    }

    return (
        <Fragment>
            {showAddMapping &&
                <AddEmployeeMapping
                    onClose={(refresh) => {
                        setShowAddMapping(false);
                        if (refresh) {
                            getEmployeeMapping();
                        }
                    }}
                />
            }
            <div>
                <DataGridHolderPayroll
                    displayTableName={"Employee Mapping"}
                    allowBulkOperation={true}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowColumnAdd={false}
                    allowRowAdd={false}
                    allowColumnSort={false}
                    refresh={false}
                    allowDataExport={false}
                    allowRowEdit={true}
                    showContextEdit={false}
                    contextMenu={true}
                    isMenuVisible={false}
                    showContextMenu={true}
                    isActionEnabled={true}
                    gridData={mappingData}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    onRowEdit={(data) => {
                        onRowEdit(data);
                    }}
                    onRowDelete={(data) => {
                        onRowDelete(data);
                    }}
                    onPaginationClick={(requestedPageNumber) => {
                        setCurrentPage(requestedPageNumber);
                    }}
                    addButtonConfig={[{
                        title: `+ ${"Employee Mapping"}`,
                        className: "bg-app text-white ml-s",
                        onClick: () => {
                            setShowAddMapping(true);
                        }
                    }]}
                />
            </div>
        </Fragment>
    );
}

export default EmployeeMapping;
